import React, { useState } from 'react'
import { createSearchParams } from 'react-router-dom'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import Row from 'react-bootstrap/Row'
import DatetimeField from '@components/DatetimeField/DatetimeField'
import SearchAccordion from '@components/Search/Accordion'
import SearchActions from '@components/Search/Actions'

function Search({ refetch, searchFilters, setSearchParams }) {
  const SEARCH_FILTERS = {
    name_cont: '',
    number_cont: '',
    created_at_gteq: '',
    created_at_lteq: ''
  }
  const [filters, setFilters] = useState({
    ...SEARCH_FILTERS,
    ...searchFilters
  })

  return (
    <SearchAccordion searchFilters={searchFilters}>
      <Form>
        <Form.Group as={Row} className='mb-3'>
          <Form.Label column sm={2} className='text-end'>
            Date range
          </Form.Label>
          <Col sm={4}>
            <InputGroup>
              <InputGroup.Text>From</InputGroup.Text>
              <DatetimeField
                name='created_at_gteq'
                value={filters.created_at_gteq}
                onChange={(name, value) => setFilters({ ...filters, [name]: value })}
              />
            </InputGroup>
          </Col>
          <Col sm={4}>
            <InputGroup>
              <InputGroup.Text>To</InputGroup.Text>
              <DatetimeField
                name='created_at_lteq'
                value={filters.created_at_lteq}
                onChange={(name, value) => setFilters({ ...filters, [name]: value })}
              />
            </InputGroup>
          </Col>
        </Form.Group>
        <Form.Group as={Row} className='mb-3'>
          <Form.Label column sm={2} className='text-end'>
            Name
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              name='name_cont'
              value={filters.name_cont}
              onChange={(event) => setFilters({ ...filters, name_cont: event.target.value })}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className='mb-3'>
          <Form.Label column sm={2} className='text-end'>
            Number
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              name='number_cont'
              value={filters.number_cont}
              onChange={(event) => setFilters({ ...filters, number_cont: event.target.value })}
            />
          </Col>
        </Form.Group>

        <SearchActions
          onReset={() => {
            setSearchParams({})
            setFilters(SEARCH_FILTERS)
          }}
          onSearch={() => {
            setSearchParams(createSearchParams(filters))
            refetch({ filters })
          }}
        />
      </Form>
    </SearchAccordion>
  )
}

export default Search
